import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { pageImages } from '../../data/siteData';
import PagePhotoViewer from '../../elements/PagePhotoViewer';

const page = {
  "slug": "paper-mills",
  "title": "Paper Mills",
  "summary": "Paper, trim, and recovered fiber systems built around steady material flow and dense, shippable bales.",
  "image": "equipment/horizontal-balers/horizontal-8.jpg",
  "highlights": [
    "Material-specific recommendations",
    "Baler loading and discharge planning",
    "Serviceable equipment design"
  ],
  "section": "Industries"
};

const navItems = [
  {
    "slug": "paper-mills",
    "title": "Paper Mills"
  },
  {
    "slug": "corrugated-container-manufacturers",
    "title": "Corrugated Container Manufacturers"
  },
  {
    "slug": "nonwoven-mills",
    "title": "Nonwoven Mills"
  },
  {
    "slug": "textile-mills-cotton-gins",
    "title": "Textile Mills & Cotton Gins"
  },
  {
    "slug": "distribution-centers",
    "title": "Distribution Centers"
  },
  {
    "slug": "manufacturers-industrial-plants",
    "title": "Manufacturers & Industrial Plants"
  },
  {
    "slug": "warehouses",
    "title": "Warehouses"
  },
  {
    "slug": "recycling-centers",
    "title": "Recycling Centers"
  }
];

const images = pageImages['paper-mills'];


function PaperMills() {
  return (
    <main className="detail-main">
      <section className="detail-layout">
        <aside>
          <span className="eyebrow">In This Section</span>
          {navItems.map((item) => (
            <Link key={item.slug} className={item.slug === page.slug ? 'active' : ''} to={`/${item.slug}`}>{item.title}</Link>
          ))}
        </aside>
        <article className="article">
          <span className="eyebrow">{page.section}</span>
          <h2>{page.title}</h2>
          <div className="body-copy page-summary-copy">{page.summary}</div>
          {page.highlights?.length ? (
            <div className="page-summary-notes">
              {page.highlights.map((item) => <span key={item}>{item}</span>)}
            </div>
          ) : null}
          <PagePhotoViewer title={page.title} images={images} leadText={"C+M balers are used for paper mill broke, paper trim, tissue trim, tissue logs, slab waste, and recovered fiber streams that need dependable transfer into dense, shippable bales."} eyebrow="Application Photos" />
          <div className="content-stack">
            <section className="content-block">
              <h3>Paper Mill Baling Applications</h3>
              <div className="body-copy">C+M balers are used for paper mill broke, paper trim, tissue trim, tissue logs, slab waste, and recovered fiber streams that need dependable transfer into dense, shippable bales.</div>
              <div className="body-copy">C+M conveyor examples include pit conveyors and sliderbed conveyors feeding tissue broke, tissue donuts, tissue logs, slab waste, and trim into <strong>horizontal automatic tie balers</strong>.</div>
              <div className="detail-points">
                <div className="detail-point">Paper trim and broke handling</div>
                <div className="detail-point">Conveyor-fed automatic tie systems</div>
                <div className="detail-point">Dense bales for storage and shipment</div>
              </div>
            </section>
          </div>
          <Link className="button" to="/contact/request-quote">Request a Quote <ArrowRight size={16} /></Link>
        </article>
      </section>
    </main>
  );
}

export default PaperMills;
